import { Typography } from '@mui/material';
import type { FC } from 'react';
import { app } from 'utils/appEnv';
import getColorPresets from 'utils/getColorPresets';

const ENV_THEME_COLORS = {
  development: 'blue',
  review: 'cyan',
  staging: 'yellow',
  preprod: 'green',
  ci: 'purple',
  production: 'blue',
} as const;

const ENV_LABELS = {
  development: 'dev',
  review: 'review',
  staging: 'staging',
  preprod: 'preprod',
  ci: 'ci',
  production: '',
};

const environmentRowText = Array(15).fill(ENV_LABELS[app.env]).join('  ');

export const EnvironmentWatermarkLine: FC = () => {
  return (
    <Typography
      sx={{
        fontSize: '16px',
        fontWeight: 600,
        letterSpacing: '0.2em',
        whiteSpace: 'nowrap',
        color: getColorPresets(ENV_THEME_COLORS[app.env]).main,
        userSelect: 'none',
        opacity: 0.2,
      }}
    >
      {environmentRowText}
    </Typography>
  );
};
